export default __webpack_public_path__ + "static/media/ARENA.d5f8f0b0.png";